import { FC } from 'react';

import { Box } from '@mui/material';

const DOTS = [
  { cx: 12, cy: 3, r: 1 },
  { cx: 16.5, cy: 4.5, r: 1.2 },
  { cx: 19.8, cy: 7.5, r: 1 },
  { cx: 21, cy: 12, r: 1 },
  { cx: 19.8, cy: 16.5, r: 1 },
  { cx: 16.5, cy: 19.5, r: 1 },
  { cx: 12, cy: 21, r: 1 },
  { cx: 7.5, cy: 19.5, r: 1 },
  { cx: 4.2, cy: 16.5, r: 1 },
  { cx: 3, cy: 12, r: 1 },
  { cx: 4.2, cy: 7.5, r: 1 },
  { cx: 7.5, cy: 4.5, r: 1 },
];

const GREY = '#8F8EA3';
const GREEN = '#31B77A';

interface UploadSpinnerProps {
  progress: number;
}

const UploadSpinner: FC<UploadSpinnerProps> = ({ progress }) => {
  const filledCount = Math.round((progress / 100) * DOTS.length);

  return (
    <Box sx={{ width: '1.5rem', height: '1.5rem', flexShrink: 0 }}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {DOTS.map((dot, i) => (
          <circle
            key={i}
            cx={dot.cx}
            cy={dot.cy}
            r={dot.r}
            fill={i < filledCount ? GREEN : GREY}
            style={{ transition: 'fill 0.3s ease' }}
          />
        ))}
      </svg>
    </Box>
  );
};

export default UploadSpinner;
